import { AppError } from "@/core/common/http/errors/app.error";

export class NotFoundError extends AppError {
  constructor(message: string, url: string) {
    super(message, 404, "Not Found", url, "No encontramos el objeto que buscas");
  }
}
